import $ from "jquery";

const mission_accordion = () => {
  const util = () => {
    $(document).ready(function () {
      mission_accordion_function();
    });
  };

  const mission_accordion_function = () => {
    const item1 = $(".mission-accordion_wrapper_accordion_content_item.item1");
    const item2 = $(".mission-accordion_wrapper_accordion_content_item.item2");
    const mission1 = $("#mission-1");
    const mission2 = $("#mission-2");

    const closesymbol1 = $("#mission-1 .rectangle-vertical");
    const closesymbol2 = $("#mission-2 .rectangle-vertical");

    const board = $(".mission-accordion_wrapper_image_container .board");
    const goggle = $(".mission-accordion_wrapper_image_container .google");

    mission1.click(function () {
      console.log("hello");
      if (item2.hasClass("active")) {
        setTimeout(function () {
          item1.toggleClass("active");
          board.toggleClass("active");
          closesymbol1.toggleClass("active");
        }, 100);
        item2.toggleClass("active");
        closesymbol2.toggleClass("active");
        goggle.toggleClass("active");
      } else {
        item1.toggleClass("active");
        closesymbol1.toggleClass("active");
        board.toggleClass("active");
      }
    });

    mission2.click(function () {
      console.log("hello2");
      if (item1.hasClass("active")) {
        setTimeout(function () {
          item2.toggleClass("active");
          closesymbol2.toggleClass("active");
          goggle.toggleClass("active");
        }, 100);
        item1.toggleClass("active");
        closesymbol1.toggleClass("active");
        board.toggleClass("active");
      } else {
        item2.toggleClass("active");
        closesymbol2.toggleClass("active");
        goggle.toggleClass("active");
      }
    });
  };
  util();
};
try {
  mission_accordion();
} catch (error) {
  console.error(error);
}
